
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/section/[sectionName]",
      function () {
        return require("private-next-pages/section/[sectionName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/section/[sectionName]"])
      });
    }
  